"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();
import type {StaticImageData} from "next/image";
import type React from "react";
import {Media} from "@/components/Media";
import Slider from "@/components/Slider";
import type {MediaBlock as MediaBlockProps} from "@/payload-types";
import {cn} from "@/utilities/ui";
import "./index.scss";
import Container from "@/components/Container";
import RichText from "@/components/RichText";

type Props = MediaBlockProps & {
	breakout?: boolean;
	captionClassName?: string;
	className?: string;
	enableGutter?: boolean;
	imgClassName?: string;
	staticImage?: StaticImageData;
	disableInnerContainer?: boolean;
};

export const MediaBlock: React.FC<Props> = (props) => {
	const { className, imgClassName, media, staticImage, richText } = props;

	const mediaItems = Array.isArray(media) ? media : media ? [media] : [];

	const renderMedia = (mediaItem: any, index?: number) => (
		<Media
			key={index}
			fill={mediaItems.length > 1}
			imgClassName={cn("border border-border rounded-[0.8rem]", imgClassName)}
			resource={mediaItem}
			src={staticImage}
		/>
	);

	return (
		<div className={cn("media_block", className)}>
			<Container>
				{richText && <RichText data={richText} />}
				{mediaItems.length > 1 ? (
					<Slider
						slides={mediaItems.map((item, index) => (
							// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
							<div key={index}>{renderMedia(item, index)}</div>
						))}
						slidesPerView={1.25}
						pagination={{ clickable: true }}
						spaceBetween={32}
						breakpoints={{
							1024: { slidesPerView: 2.25, spaceBetween: 48 },
						}}
						className="media-slider"
						id="media-slider"
						autoplay={{
							delay: 3000,
							disableOnInteraction: true,
						}}
					/>
				) : (
					<div className="media-single">
						{(mediaItems[0] || staticImage) && renderMedia(mediaItems[0])}
					</div>
				)}
			</Container>
		</div>
	);
};
